import { encrypt, decrypt } from '../utils/crypto';

export const validateTransaction = async (urlApi, transactionId) => {
    const payload = encrypt({ id: transactionId, ts: Date.now() });
    
    const response = await fetch(`${urlApi}/api/v/t`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ d: payload })
    });
    
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Validation failed');
    }
    
    const { d } = await response.json();
    return decrypt(d);
};
